import { providers } from "ethers";
import { Client } from "viem";


export const viemTransportToProvider = (client: Client) => {
  const transport = client.transport!;
  const chain = client.chain!;
  const network = {
    chainId: chain.id,
    name: chain.name,
    ensAddress: chain.contracts?.ensRegistry?.address,
  };

  return new providers.JsonRpcProvider(
    {
      url: transport.url,
      headers: transport.fetchOptions.headers,
    },
    network
  );
};
